import { render, staticRenderFns } from "./goodsMall.vue?vue&type=template&id=115b4932&scoped=true&"
import script from "./goodsMall.vue?vue&type=script&lang=js&"
export * from "./goodsMall.vue?vue&type=script&lang=js&"
import style0 from "./goodsMall.vue?vue&type=style&index=0&id=115b4932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b4932",
  null
  
)

export default component.exports